export default __webpack_public_path__ + "static/somasundaram_story-2b9a14714e334b349c6855b30aeb4101.png";